
export default {
  name: "OurVehicleCategoriesBlock",

  created: async function () {
    const category = await this.$api.agent.transport.get(`/categories/transport?expand=children`).then((res) => {
      return res.data
    }).catch(() => {
      return {}
    })

    this.category = category;
  },
  data: function () {
    return {
      category: null
    }
  },
  computed: {
    childrens: function () {
      return  this.category?.children || []
    }
  },

  components: {
    OurFleetVehicles: () => import("~/components/transport/OurFleetVehicles.vue"),
  }
}
